/**
 * Net balance for a full payment after coupon, referral rewards, and invoice-level discount.
 * Must stay in sync with getChargeableFullBalance in setc-portal-apis EasyPayFunctions.
 */
export function getChargeableFullBalance(invoice, coupon, referral) {
  const paymentAmount = Number(invoice.invoiceRemainingBalance)
  let discountAmount = 0
  if (coupon.couponAmount > 0)
    discountAmount += coupon.couponAmount > 1 ? coupon.couponAmount : Number((paymentAmount * coupon.couponAmount).toFixed(2))
  if (referral.numHaveRefund > 0)
    discountAmount += referral.numHaveRefund * 50
  if (referral.appliedReferralCode.length > 0)
    discountAmount += 50
  if (invoice.invoiceDiscount > 0)
    discountAmount += Number((invoice.invoiceRemainingBalance * invoice.invoiceDiscount).toFixed(2))

  const net = Number((paymentAmount - discountAmount).toFixed(2))
  return net > 0 ? net : 0
}
